export default [
	{ id: 0, name: 'Bitterling', price: 900, category: "Fish", },
	{ id: 1, name: 'Pale Chub', price: 200, category: "Fish", },
	{ id: 2, name: 'Crucian Carp', price: 160, category: "Fish", },
	{ id: 3, name: 'Dace', price: 240, category: "Fish", },
	{ id: 4, name: 'Carp', price: 300, category: "Fish", },
	{ id: 5, name: 'Koi', price: 4000, category: "Fish", },
	{ id: 6, name: 'Goldfish', price: 1300, category: "Fish", },
	{ id: 7, name: 'Pop-eyed Goldfish', price: 1300, category: "Fish", },
	{ id: 8, name: 'Ranchau Goldfish', price: 4500, category: "Fish", },
	{ id: 9, name: 'KilliFish', price: 300, category: "Fish", },
	{ id: 10, name: 'Crawfish', price: 200, category: "Fish", },
	{ id: 11, name: 'Soft-shelled Turtle', price: 3750, category: "Fish", },
	{ id: 12, name: 'Snapping Turtle', price: 5000, category: "Fish", },
	{ id: 13, name: 'Tadpole', price: 100, category: "Fish", },
	{ id: 14, name: 'Frog', price: 120, category: "Fish", },
	{ id: 15, name: 'Freshwater Goby', price: 400, category: "Fish", },
	{ id: 16, name: 'Loach', price: 400, category: "Fish", },
	{ id: 17, name: 'Catfish', price: 800, category: "Fish", },
	{ id: 18, name: 'Giant Snakehead', price: 5500, category: "Fish", },
	{ id: 19, name: 'Bluegill', price: 180, category: "Fish", },
	{ id: 20, name: 'Yellow Perch', price: 300, category: "Fish", },
	{ id: 21, name: 'Black Bass', price: 400, category: "Fish", },
	{ id: 22, name: 'Tilapia', price: 800, category: "Fish", },
	{ id: 23, name: 'Pike', price: 1800, category: "Fish", },
	{ id: 24, name: 'Pond Smelt', price: 500, category: "Fish", },
	{ id: 25, name: 'Sweetfish', price: 900, category: "Fish", },
	{ id: 26, name: 'Cherry Salmon', price: 1000, category: "Fish", },
	{ id: 27, name: 'Char', price: 3800, category: "Fish", },
	{ id: 28, name: 'Golden Trout', price: 15000, category: "Fish", },
	{ id: 29, name: 'Stringfish', price: 15000, category: "Fish", },
	{ id: 30, name: 'Salmon', price: 700, category: "Fish", },
	{ id: 31, name: 'King Salmon', price: 1800, category: "Fish", },
	{ id: 32, name: 'Mitten Crab', price: 2000, category: "Fish", },
	{ id: 33, name: 'Guppy', price: 1300, category: "Fish", },
	{ id: 34, name: 'Nibble Fish', price: 1500, category: "Fish", },
	{ id: 35, name: 'Angelfish', price: 3000, category: "Fish", },
	{ id: 36, name: 'Betta', price: 2500, category: "Fish", },
	{ id: 37, name: 'Neon Tetra', price: 500, category: "Fish", },
	{ id: 38, name: 'Rainbowfish', price: 800, category: "Fish", },
	{ id: 39, name: 'Piranha', price: 2500, category: "Fish", },
	{ id: 40, name: 'Arowana', price: 10000, category: "Fish", },
	{ id: 41, name: 'Dorado', price: 15000, category: "Fish", },
	{ id: 42, name: 'Gar', price: 6000, category: "Fish", },
	{ id: 43, name: 'Arapaima', price: 10000, category: "Fish", },
	{ id: 44, name: 'Saddled Bichir', price: 4000, category: "Fish", },
	{ id: 45, name: 'Sturgeon', price: 10000, category: "Fish", },
	{ id: 46, name: 'Sea Butterfly', price: 1000, category: "Fish", },
	{ id: 47, name: 'Sea Horse', price: 1100, category: "Fish", },
	{ id: 48, name: 'Clown Fish', price: 650, category: "Fish", },
	{ id: 49, name: 'Surgeonfish', price: 1000, category: "Fish", },
	{ id: 50, name: 'Butterfly Fish', price: 1000, category: "Fish", },
	{ id: 51, name: 'Napoleonfish', price: 10000, category: "Fish", },
	{ id: 52, name: 'Zebra Turkeyfish', price: 500, category: "Fish", },
	{ id: 53, name: 'Blowfish', price: 5000, category: "Fish", },
	{ id: 54, name: 'Puffer Fish', price: 250, category: "Fish", },
	{ id: 55, name: 'Anchovy', price: 200, category: "Fish", },
	{ id: 56, name: 'Horse Mackerel', price: 150, category: "Fish", },
	{ id: 57, name: 'Barred Knifejaw', price: 5000, category: "Fish", },
	{ id: 58, name: 'Sea Bass', price: 400, category: "Fish", },
	{ id: 59, name: 'Red Snapper', price: 3000, category: "Fish", },
	{ id: 60, name: 'Dab', price: 300, category: "Fish", },
	{ id: 61, name: 'Olive Flounder', price: 800, category: "Fish", },
	{ id: 62, name: 'Squid', price: 500, category: "Fish", },
	{ id: 63, name: 'Moray Eel', price: 2000, category: "Fish", },
	{ id: 64, name: 'Ribbon Eel', price: 600, category: "Fish", },
	{ id: 65, name: 'Tuna', price: 7000, category: "Fish", },
	{ id: 66, name: 'Blue Marlin', price: 10000, category: "Fish", },
	{ id: 67, name: 'Giant Trevally', price: 4500, category: "Fish", },
	{ id: 68, name: 'Mahi-Mahi', price: 6000, category: "Fish", },
	{ id: 69, name: 'Ocean Sunfish', price: 4000, category: "Fish", },
	{ id: 70, name: 'Ray', price: 3000, category: "Fish", },
	{ id: 71, name: 'Saw Shark', price: 12000, category: "Fish", },
	{ id: 72, name: 'Hammerhead Shark', price: 8000, category: "Fish", },
	{ id: 73, name: 'Great White Shark', price: 15000, category: "Fish", },
	{ id: 74, name: 'Whale Shark', price: 13000, category: "Fish", },
	{ id: 75, name: 'Suckerfish', price: 1500, category: "Fish", },
	{ id: 76, name: 'Football Fish', price: 2500, category: "Fish", },
	{ id: 77, name: 'Oarfish', price: 9000, category: "Fish", },
	{ id: 78, name: 'Barreleye', price: 15000, category: "Fish", },
	{ id: 79, name: 'Coelacanth', price: 15000, category: "Fish", },
	{ id: 80, name: "Common Butterfly", price: 160, category: "Bugs" },
	{ id: 81, name: "Yellow Butterfly", price: 160, category: "Bugs" },
	{ id: 82, name: "Tiger Butterfly", price: 240, category: "Bugs" },
	{ id: 83, name: "Peacock Butterfly", price: 2500, category: "Bugs" },
	{ id: 84, name: "Common Bluebottle", price: 300, category: "Bugs" },
	{ id: 85, name: "Paper Kite Butterfly", price: 1000, category: "Bugs" },
	{ id: 86, name: "Great Purple Emperor", price: 3000, category: "Bugs" },
	{ id: 87, name: "Monarch Butterfly", price: 140, category: "Bugs" },
	{ id: 88, name: "Emperor Butterfly", price: 4000, category: "Bugs" },
	{ id: 89, name: "Agrias Butterfly", price: 3000, category: "Bugs" },
	{ id: 90, name: "Rajah Brooke's Birdwing", price: 2500, category: "Bugs" },
	{ id: 91, name: "Queen Alexandra's Birdwing", price: 4000, category: "Bugs" },
	{ id: 92, name: "Moth", price: 130, category: "Bugs" },
	{ id: 93, name: "Atlas Moth", price: 3000, category: "Bugs" },
	{ id: 94, name: "Madagascan sunset Moth", price: 2500, category: "Bugs" },
	{ id: 95, name: "Long Locust", price: 200, category: "Bugs" },
	{ id: 96, name: "Migratory Locust", price: 600, category: "Bugs" },
	{ id: 97, name: "Rice Grasshopper", price: 160, category: "Bugs" },
	{ id: 98, name: "Grasshopper", price: 160, category: "Bugs" },
	{ id: 99, name: "Cricket", price: 130, category: "Bugs" },
	{ id: 100, name: "Bell Cricket", price: 430, category: "Bugs" },
	{ id: 101, name: "Mantis", price: 430, category: "Bugs" },
	{ id: 102, name: "Orchid Mantis", price: 2400, category: "Bugs" },
	{ id: 103, name: "Honeybee", price: 200, category: "Bugs" },
	{ id: 104, name: "Wasp", price: 2500, category: "Bugs" },
	{ id: 105, name: "Brown Cicada", price: 250, category: "Bugs" },
	{ id: 106, name: "Robust Cicada", price: 300, category: "Bugs" },
	{ id: 107, name: "Giant Cicada", price: 500, category: "Bugs" },
	{ id: 108, name: "Walker Cicada", price: 400, category: "Bugs" },
	{ id: 109, name: "Evening Cicada", price: 550, category: "Bugs" },
	{ id: 110, name: "Cicada shell", price: 10, category: "Bugs" },
	{ id: 111, name: "Red Dragonfly", price: 180, category: "Bugs" },
	{ id: 112, name: "Darner Dragonfly", price: 230, category: "Bugs" },
	{ id: 113, name: "Banded Dragonfly", price: 4500, category: "Bugs" },
	{ id: 114, name: "Damselfly", price: 500, category: "Bugs" },
	{ id: 115, name: "Firefly", price: 300, category: "Bugs" },
	{ id: 116, name: "Mole Cricket", price: 500, category: "Bugs" },
	{ id: 117, name: "Pondskater", price: 130, category: "Bugs" },
	{ id: 118, name: "Diving Beetle", price: 800, category: "Bugs" },
	{ id: 119, name: "Giant Water Bug", price: 2000, category: "Bugs" },
	{ id: 120, name: "Stinkbug", price: 120, category: "Bugs" },
	{ id: 121, name: "Man-faced Stink Bug", price: 1000, category: "Bugs" },
	{ id: 122, name: "Ladybug", price: 200, category: "Bugs" },
	{ id: 123, name: "Tiger Beetle", price: 1500, category: "Bugs" },
	{ id: 124, name: "Jewel Beetle", price: 2400, category: "Bugs" },
	{ id: 125, name: "Violin Beetle", price: 450, category: "Bugs" },
	{ id: 126, name: "Citrus Long-horned Beetle", price: 350, category: "Bugs" },
	{ id: 127, name: "Rosalia Batesi Beetle", price: 3000, category: "Bugs" },
	{ id: 128, name: "Blue Weevil Beetle", price: 800, category: "Bugs" },
	{ id: 129, name: "Dung Beetle", price: 3000, category: "Bugs" },
	{ id: 130, name: "Earth-Boring Dung Beetle", price: 300, category: "Bugs" },
	{ id: 131, name: "Scarab Beetle", price: 10000, category: "Bugs" },
	{ id: 132, name: "Drone Beetle", price: 200, category: "Bugs" },
	{ id: 133, name: "Goliath Beetle", price: 8000, category: "Bugs" },
	{ id: 134, name: "Saw Stag", price: 2000, category: "Bugs" },
	{ id: 135, name: "Miyama Stag", price: 1000, category: "Bugs" },
	{ id: 136, name: "Giant Stag", price: 10000, category: "Bugs" },
	{ id: 137, name: "Rainbow Stag", price: 6000, category: "Bugs" },
	{ id: 138, name: "Cyclommatus Stag", price: 8000, category: "Bugs" },
	{ id: 139, name: "Golden Stag", price: 12000, category: "Bugs" },
	{ id: 140, name: "Giraffe Stag", price: 12000, category: "Bugs" },
	{ id: 141, name: "Horned Dynastid", price: 1350, category: "Bugs" },
	{ id: 142, name: "Horned Atlas", price: 8000, category: "Bugs" },
	{ id: 143, name: "Horned Elephant", price: 8000, category: "Bugs" },
	{ id: 144, name: "Horned Hercules", price: 12000, category: "Bugs" },
	{ id: 145, name: "Walking Stick", price: 600, category: "Bugs" },
	{ id: 146, name: "Walking Leaf", price: 600, category: "Bugs" },
	{ id: 147, name: "Bagworm", price: 600, category: "Bugs" },
	{ id: 148, name: "Ant", price: 80, category: "Bugs" },
	{ id: 149, name: "Hermit Crab", price: 1000, category: "Bugs" },
	{ id: 150, name: "Wharf Roach", price: 200, category: "Bugs" },
	{ id: 151, name: "Fly", price: 60, category: "Bugs" },
	{ id: 152, name: "Mosquito", price: 130, category: "Bugs" },
	{ id: 153, name: "Flea", price: 70, category: "Bugs" },
	{ id: 154, name: "Snail", price: 250, category: "Bugs" },
	{ id: 155, name: "Pill bug", price: 250, category: "Bugs" },
	{ id: 156, name: "Centipede", price: 300, category: "Bugs" },
	{ id: 157, name: "Spider", price: 600, category: "Bugs" },
	{ id: 158, name: "Tarantula", price: 8000, category: "Bugs" },
	{ id: 159, name: "Scorpion", price: 8000, category: "Bugs" },
	{ id: 160, name: "Seaweed", price: 600, category: "SeaCreatures" },
	{ id: 161, name: "Sea grapes", price: 900, category: "SeaCreatures" },
	{ id: 162, name: "Sea cucumber", price: 500, category: "SeaCreatures" },
	{ id: 163, name: "Sea Pig", price: 10000, category: "SeaCreatures" },
	{ id: 164, name: "Sea Star", price: 500, category: "SeaCreatures" },
	{ id: 165, name: "Sea Urchin", price: 1700, category: "SeaCreatures" },
	{ id: 166, name: "Slate Pencil Urchin", price: 2000, category: "SeaCreatures" },
	{ id: 167, name: "Sea Anemone", price: 500, category: "SeaCreatures" },
	{ id: 168, name: "Moon Jellyfish", price: 600, category: "SeaCreatures" },
	{ id: 169, name: "Sea Slug", price: 600, category: "SeaCreatures" },
	{ id: 170, name: "Pearl Oyster", price: 2800, category: "SeaCreatures" },
	{ id: 171, name: "Mussel", price: 1500, category: "SeaCreatures" },
	{ id: 172, name: "Oyster", price: 1100, category: "SeaCreatures" },
	{ id: 173, name: "Scallop", price: 1200, category: "SeaCreatures" },
	{ id: 174, name: "Whelk", price: 1000, category: "SeaCreatures" },
	{ id: 175, name: "Turban Shell", price: 1000, category: "SeaCreatures" },
	{ id: 176, name: "Abalone", price: 2000, category: "SeaCreatures" },
	{ id: 177, name: "Gigas Giant Clam", price: 15000, category: "SeaCreatures" },
	{ id: 178, name: "Chambered Nautilus", price: 1800, category: "SeaCreatures" },
	{ id: 179, name: "Octopus", price: 1200, category: "SeaCreatures" },
	{ id: 180, name: "Umbrella Octopus", price: 6000, category: "SeaCreatures" },
	{ id: 181, name: "Vampire Squid", price: 10000, category: "SeaCreatures" },
	{ id: 182, name: "Firefly Squid", price: 1400, category: "SeaCreatures" },
	{ id: 183, name: "Gazami Crab", price: 2200, category: "SeaCreatures" },
	{ id: 184, name: "Dungeness Crab", price: 1900, category: "SeaCreatures" },
	{ id: 185, name: "Snow Crab", price: 6000, category: "SeaCreatures" },
	{ id: 186, name: "Red King Crab", price: 8000, category: "SeaCreatures" },
	{ id: 187, name: "Acorn Barnacle", price: 600, category: "SeaCreatures" },
	{ id: 188, name: "Spider Crab", price: 12000, category: "SeaCreatures" },
	{ id: 189, name: "Tiger Prawn", price: 3000, category: "SeaCreatures" },
	{ id: 190, name: "Sweet Shrimp", price: 1400, category: "SeaCreatures" },
	{ id: 191, name: "Mantis Shrimp", price: 2500, category: "SeaCreatures" },
	{ id: 192, name: "Spiny Lobster", price: 5000, category: "SeaCreatures" },
	{ id: 193, name: "Lobster", price: 4500, category: "SeaCreatures" },
	{ id: 194, name: "Giant Isopod", price: 12000, category: "SeaCreatures" },
	{ id: 195, name: "Horseshoe Crab", price: 2500, category: "SeaCreatures" },
	{ id: 196, name: "Sea Pineapple", price: 1500, category: "SeaCreatures" },
	{ id: 197, name: "Spotted Garden Eel", price: 1100, category: "SeaCreatures" },
	{ id: 198, name: "Flatworm", price: 700, category: "SeaCreatures" },
	{ id: 199, name: "Venus' Flower Basket", price: 5000, category: "SeaCreatures" },
	{ id: 200, name: "Black Cosmos", price: 240, category: "Flowers" },,
	{ id: 201, name: "Orange Cosmos", price: 80, category: "Flowers" },
	{ id: 202, name: "Pink Cosmos", price: 80, category: "Flowers" },
	{ id: 203, name: "Red Cosmos", price: 40, category: "Flowers" },
	{ id: 204, name: "White Cosmos", price: 40, category: "Flowers" },
	{ id: 205, name: "Yellow Cosmos", price: 40, category: "Flowers" },
	{ id: 206, name: "Blue Hyacinths", price: 80, category: "Flowers" },
	{ id: 207, name: "Orange Hyacinths", price: 80, category: "Flowers" },
	{ id: 208, name: "Pink Hyacinths", price: 80, category: "Flowers" },
	{ id: 209, name: "Purple Hyacinths", price: 240, category: "Flowers" },
	{ id: 210, name: "Red Hyacinths", price: 40, category: "Flowers" },
	{ id: 211, name: "White Hyacinths", price: 40, category: "Flowers" },
	{ id: 212, name: "Yellow Hyacinths", price: 40, category: "Flowers" },
	{ id: 213, name: "Black Lilies", price: 80, category: "Flowers" },
	{ id: 214, name: "Orange Lilies", price: 80, category: "Flowers" },
	{ id: 215, name: "Pink Lilies", price: 80, category: "Flowers" },
	{ id: 216, name: "Red Lilies", price: 40, category: "Flowers" },
	{ id: 217, name: "White Lilies", price: 40, category: "Flowers" },
	{ id: 218, name: "Yellow Lilies", price: 40, category: "Flowers" },
	{ id: 219, name: "Green Mums", price: 240, category: "Flowers" },
	{ id: 220, name: "Pink Mums", price: 80, category: "Flowers" },
	{ id: 221, name: "Purple Mums", price: 80, category: "Flowers" },
	{ id: 222, name: "Red Mums", price: 40, category: "Flowers" },
	{ id: 223, name: "White Mums", price: 40, category: "Flowers" },
	{ id: 224, name: "Yellow Mums", price: 40, category: "Flowers" },
	{ id: 225, name: "Blue Pansies", price: 80, category: "Flowers" },
	{ id: 226, name: "Orange Pansies", price: 80, category: "Flowers" },
	{ id: 227, name: "Purple Pansies", price: 240, category: "Flowers" },
	{ id: 228, name: "Red Pansies", price: 40, category: "Flowers" },
	{ id: 229, name: "White Pansies", price: 40, category: "Flowers" },
	{ id: 230, name: "Yellow Pansies", price: 40, category: "Flowers" },
	{ id: 231, name: "Black Roses", price: 240, category: "Flowers" },
	{ id: 232, name: "Blue Roses", price: 1000, category: "Flowers" },
	{ id: 233, name: "Gold Roses", price: 1000, category: "Flowers" },
	{ id: 234, name: "Orange Roses", price: 80, category: "Flowers" },
	{ id: 235, name: "Pink Roses", price: 80, category: "Flowers" },
	{ id: 236, name: "Purple Roses", price: 240, category: "Flowers" },
	{ id: 237, name: "Red Roses", price: 40, category: "Flowers" },
	{ id: 238, name: "White Roses", price: 40, category: "Flowers" },
	{ id: 239, name: "Yellow Roses", price: 40, category: "Flowers" },
	{ id: 240, name: "Black Tulips", price: 80, category: "Flowers" },
	{ id: 241, name: "Orange Tulips", price: 40, category: "Flowers" },
	{ id: 242, name: "Pink Tulips", price: 80, category: "Flowers" },
	{ id: 243, name: "Purple Tulips", price: 240, category: "Flowers" },
	{ id: 244, name: "Red Tulips", price: 40, category: "Flowers" },
	{ id: 245, name: "White Tulips", price: 40, category: "Flowers" },
	{ id: 246, name: "Yellow Tulips", price: 40, category: "Flowers" },
	{ id: 247, name: "Blue Windflowers", price: 80, category: "Flowers" },
	{ id: 248, name: "Orange Windflowers", price: 80, category: "Flowers" },
	{ id: 249, name: "Pink Windflowers", price: 80, category: "Flowers" },
	{ id: 250, name: "Purple Windflowers", price: 240, category: "Flowers" },
	{ id: 251, name: "Red Windflowers", price: 40, category: "Flowers" },
	{ id: 252, name: "White Windflowers", price: 40, category: "Flowers" },
]